<h1 [ngClass]="{checked: revisado === true}">{{title}}</h1>
<button (click)="close.emit()" *ngIf="closeButton">X</button>
